import React from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import useAuthCheck from "./hooks/useAuthCheck";
import routes from "./routes/routes";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <div>Checking Authentication...</div>
  ) : (
    <div>
      <RouterProvider router={routes} />

{/* react toastify container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}

export default App;
